import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";
import {
  getall,
  getQuestionByQuizzId,
  getAllQuetionQuery,
  _getAllQuizzQuery,
  _getAnswersByQuizIdQuery,
  _getQuizByIdQuery,
  getVoteByRadio,
  _getQuizByRadio,
} from "../../../graphQl/querys/quizzQuery";
import {
  getAllOptionQuery,
  getallOptionsByQuestionId,
} from "../../../graphQl/querys/optionsQuerys";
import {
  toggleQuestionStatus,
  createQuestionMutation,
  deleteQuestionMutatuion,
  UpdateQuestionMutation,
} from "../../../graphQl/mutations/questionsMution";
import {
  toggleQuizzSatuts,
  createQuizMutation,
  deleteQuizzMutation,
  UpdateQuizzMutation,
  _createFullQuizzMutation,
  _AnswerQuizMutation,
  _UpdateChartStatus,
  _updateQuizStatusMutation,
  removeQuizByIdMutation,
  _toggleQuizzSatuts
} from "@src/graphQl/mutations/QuizzMutation.js";
import {
  ToggleOptionStatus,
  createOptionMutatuion,
  deleteOptionMutation,
  updateOptionMutation,
} from "../../../graphQl/mutations/optionsMutation";

const API = process.env.REACT_APP_QUIZZ_ENDPOINT;
const VERSION = process.env.REACT_APP_QUERY_ENDPOINY;
const radio_id = localStorage.getItem("radio_id");
export const getQuizzs = (perPage, page, dispatch) => {
  //hhhhtttt
  axios
    .post(`${API}/${VERSION}`, {
      query: getVoteByRadio(radio_id, perPage, page),
    })
    .then((response) => {
      //totalItems
      //itemCount
      dispatch({
        type: "GET_ALL_QUIZZ",
        data: response?.data?.data?.getQuizByRadioPaginate?.items,
        total: response?.data?.data?.getQuizByRadioPaginate?.totalItems,
        count: response?.data?.data?.getQuizByRadioPaginate?.itemCount,
      });
    });
};

export const getQuetionByQuizzId = (id, fields, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: getQuestionByQuizzId(id, fields) })
    .then((response) => {
      dispatch({
        type: "GET_ALL_QUESTION_BY_QUIZZ_ID",
        data: response.data.data.getQues,
      });
    });
};

export const UpdateQuizz = (id, Dto, fields, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: UpdateQuizzMutation(id, Dto, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne("Quizz updated succesfully");
        getQuizzs(
          500,1,
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};

export const getAllQuetion = (fields, children, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: getAllQuetionQuery(fields, children) })
    .then((response) => {
      dispatch({
        type: "GET_ALL_QUESTION",
        data: response.data.data,
      });
    });
};

export const updateQuizzStatus = (fields, id, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: toggleQuizzSatuts(id, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne(t("Quizz status updated succesfully"));
        getQuizzs(
          500,1,
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};


export const _updateQuizzStatus = ( id, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: _toggleQuizzSatuts(id) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne(t("Quizz status updated succesfully"));
        _getAllQuizz(
          500,1,
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};

export const updateQuestionStatus = (fields, id, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: toggleQuestionStatus(id, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne("question status updated succesfully");
        getAllQuetion(
          ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
          ["id", "title", "is_active", "createdAt", "updatedAt"],
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};

export const updateQuestionStatus_getbyIdComponent = (
  fields,
  quesId,
  QuizzId,
  dispatch
) => {
  axios
    .post(`${API}/${VERSION}`, { query: toggleQuestionStatus(quesId, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne("question status updated succesfully");
        getQuetionByQuizzId(
          QuizzId,
          ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};

export const getallOptions = (fields, child, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: getAllOptionQuery(fields, child) })
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: "GET_ALL_OPTIONS",
          data: response.data.data.getAllOptions,
        });
      }
    });
};

export const updateOptionStatus = (id, fields, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: ToggleOptionStatus(id, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne("Question status updated succesfully");
        getallOptions(
          [
            "id",
            "opt_text",
            "is_correct",
            "is_active",
            "createdAt",
            "updatedAt",
          ],
          ["id", "ques_text", "createdAt", "updatedAt"],
          dispatch
        );
      } else {
        handleErrorOne("error");
      }
    });
};

export const getAllOptionsByQuestionId = (id, fields, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: getallOptionsByQuestionId(id, fields) })
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: "GET_OPTION_BY_QUESTION_ID",
          data: response.data.data.getOptionsByQuestionID,
        });
      } else {
        handleErrorOne("error");
      }
    });
};

export const updateOptionStatus_nested = (id, fields, dispatch, refrech) => {
  axios
    .post(`${API}/${VERSION}`, { query: ToggleOptionStatus(id, fields) })
    .then((response) => {
      if (response.status === 200) {
        handleSuccessOne("question status updated succesfully");
        refrech();
      } else {
        handleErrorOne("error");
      }
    });
};

export const createQuizz = (CreateQuizzDto, dispatch, t) => {
  if (CreateQuizzDto.title.length === 0) {
    handleErrorOne("title must be not empty");
    return;
  }
  axios
    .post(`${API}/${VERSION}`, { query: createQuizMutation(CreateQuizzDto) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("vote created successfully"));
        getQuizzs(
          500,1,
          dispatch
        );
      }
    });
};

export const deleteQuiz = (id, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: deleteQuizzMutation(id) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("Quiz deleted successfully"));
        getQuizzs(
          500,1,
          dispatch
        );
      }
    });
};


export const deleteQuizById = (id, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: removeQuizByIdMutation(id) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("Quiz deleted successfully"));
        _getAllQuizz(
          500,1,
          dispatch
        );
      }
    });
};





//removeQuizByIdMutation

export const createQuestion = (Dto, dispatch) => {
  if (!Dto.quiz) {
    handleErrorOne("you should chose a quiee for this question");
    return;
  }
  if (Dto.title.length === 0) {
    handleErrorOne("question text shouldn't be empty");
    return;
  }
  axios
    .post(`${API}/${VERSION}`, { query: createQuestionMutation(Dto) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne("question has been created successfully");
        getAllQuetion(
          ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
          ["id", "title", "is_active", "createdAt", "updatedAt"],
          dispatch
        );
      } else {
        handleErrorOne("question was not created");
      }
    });
};

export const deleteQuetion = (id, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: deleteQuestionMutatuion(id) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne("Question deleted successfully");
        getAllQuetion(
          ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
          ["id", "title", "is_active", "createdAt", "updatedAt"],
          dispatch
        );
      } else {
        handleErrorOne("error accured while deletin this item");
      }
    });
};

export const updateQuestion = (id, Dto, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, { query: UpdateQuestionMutation(id, Dto) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne("Question updated successfully");
        getAllQuetion(
          ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
          ["id", "title", "is_active", "createdAt", "updatedAt"],
          dispatch
        );
      }
    });
};

export const createOption = (dto, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: createOptionMutatuion(dto) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("Answer updated successfully"));
        getallOptions(
          [
            "id",
            "opt_text",
            "is_correct",
            "is_active",
            "createdAt",
            "updatedAt",
          ],
          ["id", "ques_text", "createdAt", "updatedAt"],
          dispatch
        );
      }
    });
};

export const deleteOption = (id, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: deleteOptionMutation(id) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("Answer deleted successfully"));
        getallOptions(
          [
            "id",
            "opt_text",
            "is_correct",
            "is_active",
            "createdAt",
            "updatedAt",
          ],
          ["id", "ques_text", "createdAt", "updatedAt"],
          dispatch
        );
      }
    });
};

export const updateOption = (id, dto, dispatch, t) => {
  axios
    .post(`${API}/${VERSION}`, { query: updateOptionMutation(id, dto) })
    .then((res) => {
      if (res.status === 200) {
        handleSuccessOne(t("Answer updated successfully"));
        getallOptions(
          [
            "id",
            "opt_text",
            "is_correct",
            "is_active",
            "createdAt",
            "updatedAt",
          ],
          ["id", "ques_text", "createdAt", "updatedAt"],
          dispatch
        );
      }
    });
};

export const CreateFullQuiz = (quizz,handelSuccess) => {
  quizz.radio_id = radio_id;
  axios
    .post(`${API}/fullquizz`, quizz)
    .then((res) => {
      handleSuccessOne("Vote successfully created");
      handelSuccess()
    })
    .catch((err) => {
      handleErrorOne("Vote failed to be created");
    });
};

export const _createFullQuizzAction = (quizzDto) => {
  quizzDto.radio_id = radio_id;

  axios
    .post(`${API}/${VERSION}`, {
      query: _createFullQuizzMutation(quizzDto, radio_id),
    })
    .then((res) => {
      handleSuccessOne("Vote successfully created");
    })
    .catch((err) => {
      handleErrorOne("Vote failed to be created");
    });
};

export const _getAllQuizz = (perPage, page, dispatch) => {
  axios
    .post(`${API}/${VERSION}`, {
      query: _getQuizByRadio(radio_id, perPage, page),
    })
    .then((res) => {
      dispatch({
        type: "_GET_ALL_QUIZ",
        data: res?.data?.data?._findAllQuizesByradioPagination?.items,
        total: res?.data?.data?._findAllQuizesByradioPagination?.totalItems,
        count: res?.data?.data?._findAllQuizesByradioPagination?.itemCount,
      });
    })
    .catch((err) => {});
};

export const _getAnswersByQuizID = (dispatch, quiz_id) => {
  axios
    .post(`${API}/${VERSION}`, { query: _getAnswersByQuizIdQuery(quiz_id) })
    .then((res) => {
      dispatch({
        type: "_GET_ANSWERS_BY_QUIZ_Id",
        data: res?.data?.data?._getAnswerByQuizId,
      });
    });
};

export const _getQuizById = (dispatch, quiz_id) => {
  axios
    .post(`${API}/${VERSION}`, { query: _getQuizByIdQuery(quiz_id) })
    .then((res) => {
      dispatch({
        type: "_GET_QUIZ_BY_ID",
        data: res.data.data._findOneQuiz,
      });
    });
};

export const _AnswerQuizAction = (
  dispatch,
  quiz_id,
  updateDto,
  handelCanselVote
) => {
  axios
    .post(`${API}/${VERSION}`, {
      query: _AnswerQuizMutation(quiz_id, updateDto),
    })
    .then((res) => {
      _getQuizById(dispatch, quiz_id);
      handleSuccessOne("answer saved successfully");
      handelCanselVote();
    })
    .catch((err) => {
      handleErrorOne("failed to save answers");
    });
};

export const _UpdateDonutChartStatus = (dispatch, quiz_id, updateDto) => {
  axios
    .post(`${API}/${VERSION}`, {
      query: _UpdateChartStatus(quiz_id, updateDto),
    })
    .then((res) => {
      _getAllQuizz(5,1,dispatch);
      handleSuccessOne("chart status updated successfully");
    })
    .catch((err) => {
      handleErrorOne("failed to save answers");
    });
};

export const answerFullVote = (dispatch, Vote_id, quizDto,backtoStep) => {
  axios
    .post(`${API}/fullquizz/answerFullVote/${Vote_id}`, quizDto)
    .then((res) => {
      getQuetionByQuizzId(
        Vote_id,
        ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
        dispatch
      );
      backtoStep()
      handleSuccessOne("answe submitted successfully");
    });
};

export const _toggleAnswerStatusAction = (dispatch, quiz_id, ans_id) => {
  axios
    .post(`${API}/${VERSION}`, {
      query: _updateQuizStatusMutation(ans_id),
    })
    .then((res) => {
      _getQuizById(dispatch, quiz_id);
      handleSuccessOne("answer status updated successfully");
    })
    .catch((err) => {
      handleErrorOne("failed to save answers");
    });
};

//['id', 'ques_text', 'is_active', 'createdAt', 'updatedAt']
